import type {
	ContentType,
	Distribution,
	MixedItemDistResponse,
	MixedItemTag,
} from "@memorang/types";

type Content = {
	id: string;
	type: ContentType;
	distribution: Distribution;
	totalCount: number;
};

const fetchContentsDist = async (_bundleId: string) => {
	return {
		getMixedItemDistribution: {
			iconUrl: "",
			title: "",
			contents: [] as Content[],
			freeTagIds: [] as string[],
			tags: [] as MixedItemTag[],
		} satisfies MixedItemDistResponse,
	};
};

export default fetchContentsDist;
